export default __webpack_public_path__ + "static/media/search.6236cd7d.svg";